













































































































































import Vue, { PropType } from 'vue';
import { IPayrollChangeRequest } from '@/models';
import PayrollChangeRequestStatusDisplay from '../requisition-common/PayrollChangeRequestStatusDisplay.vue';

export default Vue.extend({
  name: 'PayrollChangeRequestDetailDrawer',

  components: { PayrollChangeRequestStatusDisplay },

  props: {
    payrollChangeRequest: {
      type: Object as PropType<IPayrollChangeRequest>,
      required: true
    }
  },

  data: () => ({
    mini: true,
    drawer: true
  })
});
